import AllowancesField from '@apps/subscriptions/admin/components/allowancesfield'
import FrequencyField from '@apps/subscriptions/admin/components/frequencyfield'
import RevenueTypeToken from '@apps/finance/admin/tokens/revenue_type'
import ProjectToken from '@apps/finance/admin/tokens/project'
import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Edit extends React.Component {

  static contextTypes = {
    modal: PropTypes.object,
    router: PropTypes.object
  }

  static propTypes = {
    plan: PropTypes.object,
    service: PropTypes.object
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form {...this._getForm()} />
  }

  _getForm() {
    const { plan, service } = this.props
    return {
      title: 't(Edit Plan)',
      method: 'PATCH',
      endpoint: `/api/admin/subscriptions/services/${service.id}/plans/${plan.id}/edit`,
      action: `/api/admin/subscriptions/services/${service.id}/plans/${plan.id}`,
      onCancel: this._handleCancel,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { label: 't(Title)', name: 'title', type: 'textfield', required: true },
            { label: 't(Line Item Description)', name: 'line_item_description', type: 'textfield', required: true },
            ...plan.type === 'paid' ? [
              { label: 't(Pricing)', type: 'segment', fields: [
                { type: 'fields', fields: [
                  { label: 't(Project)', name: 'project_id', type: 'lookup',  endpoint: '/api/admin/finance/projects', valueKey: 'id', textKey: 'display', required: true, format: ProjectToken },
                  { label: 't(Revenue Type)', name: 'revenue_type_id', type: 'lookup', endpoint: '/api/admin/finance/revenue_types', valueKey: 'id', textKey: 'display', required: true, format: RevenueTypeToken }
                ] },
                { label: 't(Base Price)', name: 'price', type: 'moneyfield', required: true }
              ] },
              ...service.model === 'metered' ? [
                { label: 't(Resource Allowances)', name: 'allowances', type: AllowancesField, plan, service, required: true }
              ] : []
            ] : [],
            { label: 't(Renewal Frequency)', name: 'frequency', type: FrequencyField, required: true, defaultValue: service.frequency }
          ]
        }
      ]
    }
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleSuccess(service) {
    this.context.modal.close()
  }

}

export default Edit
